import { render, staticRenderFns } from "./WelfareDetailSide.vue?vue&type=template&id=7b2308c5&scoped=true&"
import script from "./WelfareDetailSide.vue?vue&type=script&lang=js&"
export * from "./WelfareDetailSide.vue?vue&type=script&lang=js&"
import style0 from "./WelfareDetailSide.vue?vue&type=style&index=0&id=7b2308c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2308c5",
  null
  
)

export default component.exports